

import { ThemeProvider, CssBaseline } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { LoadingContainer } from './loading-container/LoadingContainer';
import { MainRouter } from './router/main';
import { ToastAlert } from './toast-alert';
import { theme } from "./styles";
import { ModalContainer } from './modal-container';
import { useAuthRepository } from '../infra/auth';
import { useAppDispatch, useAppSelector } from './hooks/store-hooks';
import { setToken } from '../application/states/auth';

function App() {
  const dispatch = useAppDispatch();
  const stateToken = useAppSelector((state) => state.auth.token);
  const hasToken = !!(stateToken || localStorage.getItem('ACCESS_TOKEN'));
  const { getSessionConfig, refreshToken } = useAuthRepository();
  const refreshTokenRef = useRef(refreshToken);
  refreshTokenRef.current = refreshToken;

  useEffect(() => {
    let isMounted = true;
    let interval: ReturnType<typeof setInterval> | undefined;

    const logout = () => {
      localStorage.removeItem('ACCESS_TOKEN');
      localStorage.removeItem('SESSION_START_TIMESTAMP');
      const loginUrl =
        process.env.REACT_APP_VELES_LOGIN_URL ||
        (process.env.REACT_APP_VELES_MODULES_URL || '').replace('/modulos', '/authentication/login');
      window.location.replace(loginUrl);
    };

    const isIpBlock = (msg: unknown) =>
      typeof msg === 'string' && msg.toLowerCase().includes('ip');

    const refresh = async () => {
      const token = localStorage.getItem('ACCESS_TOKEN');
      if (!token) return;

      try {
        const data = await refreshTokenRef.current(token);
        if (data.Autenticado) {
          localStorage.setItem('ACCESS_TOKEN', data.Token);
          dispatch(setToken({ token: data.Token }));
        } else {
          if (!isIpBlock(data.Mensagem)) logout();
        }
      } catch (error: any) {
        const resData = error?.response?.data || {};
        const msg = resData.message || resData.error || resData.Mensagem || resData.mensagem || '';
        
        if (!isIpBlock(msg) && error?.response?.status === 401) logout();
      }
    };

    const start = async () => {
      if (!hasToken) return;
      try {
        const { result } = await getSessionConfig();
        if (!isMounted) return;
        interval = setInterval(refresh, result.refreshIntervalSeconds * 1000);
      } catch (error) {
        console.error('Erro ao carregar configurações de sessão:', error);
      }
    };

    start();

    return () => {
      isMounted = false;
      if (interval) clearInterval(interval);
    };
  }, [dispatch, getSessionConfig, hasToken]);

  return (
    <ThemeProvider theme={theme}>
      <ModalContainer />
      <CssBaseline />
      <ToastAlert />
      <LoadingContainer />
      <MainRouter />
    </ThemeProvider>
  );
}

export default App;